import React from "react";
import { Link } from "react-router-dom";
import { Hammer, ArrowRight } from "lucide-react";

export default function AdminPlaceholder({ title, description }) {
  return (
    <div data-testid={`admin-placeholder-${(title || "section").toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="overline mb-2">Module en construction</div>
      <h1 className="serif text-4xl md:text-5xl text-[var(--gai-black)] leading-none">
        {title || "Section"}
      </h1>
      <p className="mt-3 text-sm text-[var(--gai-grey-500)] max-w-2xl">
        {description ||
          "Ce module fait partie de la refonte CRM en cours. Il sera disponible dans une prochaine mise en ligne."}
      </p>

      <div className="mt-10 gai-card gai-sharp p-10 flex items-center gap-6 max-w-3xl">
        <div
          className="w-14 h-14 flex items-center justify-center"
          style={{ background: "var(--gai-red-soft)", color: "var(--gai-gold)" }}
        >
          <Hammer size={22} />
        </div>
        <div className="flex-1">
          <div className="serif text-xl text-[var(--gai-black)]">Bientôt disponible</div>
          <p className="text-sm text-[var(--gai-grey-600)] mt-1">
            En attendant, vous pouvez utiliser la console historique pour gérer cette section.
          </p>
        </div>
        <Link to="/admin/console" className="gai-btn-gold text-xs" data-testid="admin-placeholder-console">
          Console historique <ArrowRight size={12} />
        </Link>
      </div>
    </div>
  );
}
